<mat-form-field>
  <mat-label>{{ title }}</mat-label>
  <mat-chip-grid #chipList aria-label="Tag selection">
    @for (tag of selectedTags; track tag) {
    <mat-chip-row
      [ngClass]="bgClass"
      [removable]="true"
      (removed)="remove(tag)"
    >
      {{ tag }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip-row>
    }
    <input
      placeholder="Tag"
      matInput
      #tagInput
      [formControl]="formControl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (tag of filteredTags | async; track tag) {
    <mat-option [value]="tag">
      {{ tag }}
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
